import React, {useState} from 'react';
import { Button, Card, ListGroup } from 'react-bootstrap';
import Form from 'react-bootstrap/Form'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router';
import '../../css/master.css';

export default function ViewTicketInfo() {

    const navigate = useNavigate();

    const [isOpen,setvar] = useState(true)

    return (
        <>
            <div className='left'>
                { isOpen ? <p className='isOpen'>TICKET IS CURRENTLY OPEN</p> : <p className='isClosed'>TICKET IS CLOSED</p> }
                <p><b>Ticket ID: </b>TID</p>
                <p><b>Comments: </b>status</p>
                <p><b>Ticket Type: </b>Ticket Type</p>
                <p><b>Project: </b>Project Name</p>
                <p><b>Description: </b>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
            </div>
        </>
    )
}